// Recovered compiled webpack factory 85236. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { RV: () => f, gd: () => i, nY: () => d, qQ: () => c, vk: () => s, yF: () => n });
  let n = "?",
    a = /\(error: (.*)\)/,
    o = /captureMessage|captureException/;
  function i(...e) {
    let t = e.sort((e, t) => e[0] - t[0]).map((e) => e[1]);
    return (e, r = 0, i = 0) => {
      let s = [],
        u = e.split("\n");
      for (let e = r; e < u.length; e++) {
        let r = u[e];
        r.length > 1024 && (r = r.slice(0, 1024));
        let n = a.test(r) ? r.replace(a, "$1") : r;
        if (!n.match(/\S*Error: /)) {
          for (let e of t) {
            let t = e(n);
            if (t) {
              s.push(t);
              break;
            }
          }
          if (s.length >= 50 + i) break;
        }
      }
      var c = s.slice(i);
      if (!c.length) return [];
      let f = Array.from(c);
      return (
        /sentryWrapped/.test(l(f).function || "") && f.pop(),
        f.reverse(),
        o.test(l(f).function || "") && (f.pop(), o.test(l(f).function || "") && f.pop()),
        f
          .slice(0, 50)
          .map((e) => ({ ...e, filename: e.filename || l(f).filename, function: e.function || n }))
      );
    };
  }
  function s(e) {
    return Array.isArray(e) ? i(...e) : e;
  }
  function l(e) {
    return e[e.length - 1] || {};
  }
  let u = "<anonymous>";
  function c(e) {
    try {
      if (!e || "function" != typeof e) return u;
      return e.name || u;
    } catch {
      return u;
    }
  }
  function f(e) {
    let t = e.exception;
    if (t) {
      let e = [];
      try {
        return (
          t.values.forEach((t) => {
            t.stacktrace.frames && e.push(...t.stacktrace.frames);
          }),
          e
        );
      } catch {}
    }
  }
  function d(e) {
    return "__v_isVNode" in e && e.__v_isVNode ? "[VueVNode]" : "[VueViewModel]";
  }
}
